export const clientDetailsTableConfig = [
  {
    field: 'slNo',
    header: 'SI.No',
    className: 'finance-client-details-first-column',
    headerClassName: 'finance-client-details-first-column',
    filter: false,
    visible: true,
    defaultPinned: true,
    sortable: false,
    order: 1,
    menuItems: [],
  },
  {
    field: 'clientId',
    header: 'Client ID',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 2,
    menuItems: [],
  },
  {
    field: 'clientName',
    header: 'Client Name',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 3,
    menuItems: [],
  },
  {
    field: 'clientStatusLabel',
    header: 'Client Status',
    exportField: 'clientStatusLabel',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 4,
    menuItems: [],
  },
  {
    field: 'totalProjectsLinked',
    header: 'Total Projects Linked',
    className: 'finance-client-details-number-column',
    headerClassName: 'finance-client-details-number-column',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 5,
    menuItems: [],
  },
  {
    field: 'action',
    header: 'Action',
    className: 'finance-client-details-action-column',
    headerClassName: 'finance-client-details-action-column',
    width: 150,
    exportable: false,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 6,
    menuItems: [],
  },
];
